import { client } from "@nju/http-client";
import { serverResponse } from "./validators";

export async function fetchUserData(userId: string | undefined) {
  const env = process.env.NEXT_PUBLIC_APP_ENV;

  const apikey =
    env === "int"
      ? process.env.NEXT_PUBLIC_INT_GATEWAY_APIKEY
      : process.env.NEXT_PUBLIC_DEV_GATEWAY_APIKEY;

  const auth =
    env === "int"
      ? process.env.NEXT_PUBLIC_INT_GATEWAY_AUTH
      : process.env.NEXT_PUBLIC_DEV_GATEWAY_AUTH;

  const result = await client(
    `https://${env}-helpers.dopapp.pl/users/${userId}`,
    {
      headers: {
        version: "1",
        apikey: `${apikey}`,
        Authorization: `Basic ${auth}`,
        accept: "application/json",
        "Content-Type": "application/json",
      },
      validator: serverResponse,
    },
  );

  return result;
}
